<script>
import MultitabPicker from '~/components/common/multitab-picker';
import debounce from 'lodash/debounce';
import { TOUR_ORIGIN } from '~endpoints';

export default {
    extends: MultitabPicker,

    data () {
        return {
            fetchedCities: null,
            isUserTyped: false,
        };
    },

    computed: {
        tabs () {
            return [this.$t('common.highTrafficCities')];
        },
        options () {
            let options;
            if (this.isUserTyped) {
                options = (this.fetchedCities || []).reduce((carry, item) => carry.concat(item.places || []), []);
            } else {
                const r = this.fetchedCities;
                // let tabIndex = this.tabs.indexOf(this.selectedTab);
                // need to remove later. just for now (backend is not ready!)
                const tabIndex = 0;
                if (!r || tabIndex === -1) return [];
                options = (r[tabIndex].places || []);
            }
            return options.map(el => ({
                title: el.name,
                subtitle: (el.displayName.find(d => d.language === 'en-US') || { value: '' }).value,
                id: el.domainCode,
                originId: el.id,
            }));
        },
    },

    mounted () {
        this.fetchCities();
    },

    methods: {
        onSearchChange (query) {
            this.isUserTyped = !!query;
            this.fetchCities(query);
        },

        fetchCities: debounce(function (query) {
            this.loading = true;
            return this.$axios.$get(`${TOUR_ORIGIN}?query=${query || ''}`)
                .then(response => {
                    this.loading = false;
                    this.fetchedCities = response.result;
                })
                .catch(err => {
                    this.loading = false;
                    this.fetchedCities = null;
                    console.error(err); // eslint-disable-line no-console
                });
        }, 200),
    },
};
</script>

<style lang="scss" scoped>
.multitab-picker {

    &__dropdown {
        width: 330px;
        @media (max-width: 767px) {
            width: 100%;
        }
    }

    &__tabs {

        > li {
            margin-bottom: 1px;
        }
    }
}
</style>
